import React, { useState, useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import ModalImage from "react-modal-image";
import Typography from "@material-ui/core/Typography";
import BrokenImageIcon from "@material-ui/icons/BrokenImage";
import api from "../../services/api";

const useStyles = makeStyles(theme => ({
	messageMedia: {
		objectFit: "cover",
		width: 250,
		height: "auto", // Redimensionar automaticamente a altura para manter a proporção
		display: "block",
		borderTopLeftRadius: 8,
		borderTopRightRadius: 8,
		borderBottomLeftRadius: 8,
		borderBottomRightRadius: 8,
	},
	fallbackContainer: {
		width: 250,
		minHeight: 120,
		display: "flex",
		flexDirection: "column",
		alignItems: "center",
		justifyContent: "center",
		backgroundColor: "rgba(0, 0, 0, 0.04)",
		borderRadius: 8,
		padding: 12,
		color: "#888",
		border: "1px dashed #ccc",
	}
}));

const ModalImageCors = ({ imageUrl }) => {
	const classes = useStyles();
	const [fetching, setFetching] = useState(true);
	const [blobUrl, setBlobUrl] = useState("");
	const [hasError, setHasError] = useState(false);

	useEffect(() => {
		if (!imageUrl) {
			setFetching(false);
			setHasError(true);
			return;
		}
		
		let isMounted = true;

		// Validar se a URL é válida antes de fazer a requisição
		try {
			// Se a URL não começa com http, pode ser um caminho relativo
			if (!imageUrl.startsWith('http') && !imageUrl.startsWith('/')) {
				console.warn('URL de imagem inválida:', imageUrl);
				setFetching(false);
				setHasError(true);
				return;
			}
		} catch (e) {
			console.warn('Erro ao validar URL de imagem:', e);
			setFetching(false);
			setHasError(true);
			return;
		}
		
		const fetchImage = async () => {
			try {
				setFetching(true);
				setHasError(false);
				const { data, headers } = await api.get(imageUrl, {
					responseType: "blob",
				});
				if (isMounted) {
					const url = window.URL.createObjectURL(
						new Blob([data], { type: headers["content-type"] })
					);
					setBlobUrl(url);
				}
			} catch (error) {
				console.warn('Erro ao carregar imagem:', error);
				if (isMounted) {
					setHasError(true);
				}
			} finally {
				if (isMounted) {
					setFetching(false);
				}
			}
		};

		fetchImage();

		return () => {
			isMounted = false;
			if (blobUrl) {
				window.URL.revokeObjectURL(blobUrl);
			}
		};
	}, [imageUrl]);

	if (hasError || (!fetching && !blobUrl && !imageUrl)) {
		return (
			<div className={classes.fallbackContainer}>
				<BrokenImageIcon style={{ fontSize: 36, color: "#999", marginBottom: 6 }} />
				<Typography variant="caption" style={{ color: "#888", textAlign: "center" }}>
					Mídia indisponível
				</Typography>
			</div>
		);
	}

	const src = blobUrl || imageUrl;

	return (
		<ModalImage
			className={classes.messageMedia}
			smallSrcSet={src}
			medium={src}
			large={src}
			alt="image"
			showRotate={true}
		/>
	);
};

export default ModalImageCors;
